export enum ZoomSliderMode {
  GLOBAL = 'global',
  LANE = 'lane',
  SINGLE = 'single',
}
